// @flow

import type { UserInputValues } from '@tectonics/prs/user-input-values';

export const COLOMBIA_COUNTRY_CODE = '57';

export function isNequiPayment(userInputValues: UserInputValues): boolean {
  return userInputValues['selectedEWallet'] === 'nequi' && userInputValues['selectedPaymentMethod'] === 'ewallet';
}
